import Header from "../components/header";
import PageTitle from "../components/page-title";
import PageNavigator from "../components/page-navigator";
import FeedHolder from "../components/feed-holder";
import Holder from "../components/holder";
import InputModule from "../components/input-module";
import { useState,useEffect } from "react";
import { openSiteAdder } from "../functions/openInput";
import { fetchVoices } from "../functions/fetchVoices";
import InsightsHolder from "../components/insights-holder";
import { fetchInsights } from "../functions/fetchInsights";
import CustomPostModule from "../components/custom-post-module";
import { openCustomPostModule } from "../functions/openCustomPostModule";


function InsightsPage(){
    //SCHEMA FOR IDEAS ITEM = {date:'09 Jun 2024',title:'Why you shouldn’t compare',status:2,generatedFrom:'Why I Am Perfect And All My Competitors Suck'},
    const DISMISSED_KEY = "mako-dismissed-insights";
    const loadDismissed = () => {
      try {
        const raw = localStorage.getItem(DISMISSED_KEY);
        return raw ? new Set(JSON.parse(raw)) : new Set();
      } catch {
        return new Set();
      }
    };
    const [inputOpen,setInputOpen] = useState(false);
    const [insights,setInsights] = useState([]);
    const [dismissedIds, setDismissedIds] = useState(() => loadDismissed());
    const [voices,setVoices]= useState(null)
    const [fullyLoaded, changeFullyLoaded] = useState(false);

    const insightId = (item) => `${item.url}-${item.dateDetected}`;
    const visibleInsights = insights.filter((item) => !dismissedIds.has(insightId(item)));
    const handleDismiss = (item) => {
      const id = insightId(item);
      setDismissedIds((prev) => {
        const next = new Set(prev);
        next.add(id);
        localStorage.setItem(DISMISSED_KEY, JSON.stringify([...next]));
        return next;
      });
    };

    const handleClick = () => {
        openSiteAdder(setInputOpen,inputOpen);
    }

        const [customPostModuleOpen,setCustomPostModuleOpen] = useState(false);
    
        const handleClick2 = () =>{
            openCustomPostModule(setCustomPostModuleOpen,customPostModuleOpen)
        }
    

    useEffect(() => {
        const waitForIdeas = async() => {
        await fetchInsights(setInsights);
        fetchVoices(setVoices);
        changeFullyLoaded(true);
        }
        waitForIdeas();
      }, []);

    return <>
    <Header CTA='Add site' functionForButton={handleClick} CTA2="Create post" functionForButton2={handleClick2} context="ideas"></Header>
    <Holder 
    left={<PageNavigator numberSelected={2}/>}
    right={<><PageTitle text='Here are your insights from your scanned sites.' heading='Your insights'></PageTitle>
    <InsightsHolder loadStatus={fullyLoaded} items={visibleInsights} openSiteAdder={handleClick} onDismiss={handleDismiss} />
    </>}
    />
    <InputModule functionForButton={handleClick} display={inputOpen ? 'flex' : 'none'}/>
    <CustomPostModule loadedVoices={voices} display={customPostModuleOpen ? 'flex' : 'none'} functionForButton={handleClick2} />
    </>
}
    
export default InsightsPage;